import script from "./Unsubscribe.vue?vue&type=script&setup=true&lang=js"
export * from "./Unsubscribe.vue?vue&type=script&setup=true&lang=js"

import "./Unsubscribe.vue?vue&type=style&index=0&id=e57d2eda&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e57d2eda"]])

export default __exports__